import Vue from "vue";

const paramFormulaire = {
  codeFormulaireInscription: "Inscription",
  codeFormulaireRenouvellement: "Renouvellement",
  codeFormulaireUnitaire: "Unitaire",
  codeFormulaireAdmissionInitiale: "AdmissionInitiale",
  codeFormulaireAdmissionComplementaire: "AdmissionComplementaire",
  codeFormulaireAdmissionPA: "AdmissionPA",
  codeFormulaireAdmissionPRP: "AdmissionPRP",
  codeFormulaireReAdmission: "ReAdmission",
  codeFormulaireConfirmation: "Confirmation",
  codeFormulaireUIEI: "UIEI",
  codeFormulaireDemission: "Demission",

  infoText: "info",
  avertissementText: "warning",
  erreurText: "error",
  successText: "success",
  paragraphText: "text",

  infoColor: "secondary",
  warningColor: "orange",
  errorColor: "red lighten-2",
  successColor: "green",
  defaultColor: "#dddddd",
};

export const cataloguesDesc = {
  titreDePreference: 223,
  genre: 265,
  pni: 224,
  nationsInuit: 258, // Contact.NationsInuit
  pays: 303, // Organisations.Pays
  province: 313, // Organisations.Province
  fonction: 413, // Carte d'affaire.Fonction
  heuresPratiqueAutonome: 424, // Carte d'affaire.Nombre d'heure de travail en pratique autonome
  adapteHandicape: 425, // Carte d'affaire.Installations adaptées aux personnes handicapées
  domaineDePratique: 426, // Carte d'affaire.Domaines de pratique
  typeClientele: 427, // Carte d'affaire.Types de clientèle desservie
  methodeIntervention: 428, // Carte d'affaire.Méthodes d'intervention
  approcheIntervention: 429, // Carte d'affaire.Approches d'intervention
  serviceOffert: 431, // Carte d'affaire.Services offerts
  typeTherapie: 452, // Carte d'affaire.Thérapie/Techniques d'intervention
  typeActiviteReservee: 453, // Carte d'affaire.Expertise légales / activités réservées
  typeProbleme: 454, // Carte d'affaire.Problèmes sociaux généraux
  serviceReferenceEnLigne: 458, // Carte d'affaire.Service de référence en ligne
  sexe: 1513, // Demandes admission.Sexe
  paysOrigine: 1514, // Demandes admission.Pays d'origine
  citoyennete: 1546, // Demandes admission.Citoyenneté(s)
  motifsRenonciation: 1561, // Demandes admission.Motif(s) renonciation
  langue: 1901,
  decisionDisciplinaireAutreOrdre: 2103, // Déclarations obligatoires.Décision disciplinaire d'un autre ordre professionnel
  decisionTribunalCanadienOuEtranger: 2115, // Déclarations obligatoires.Décision d'un tribunal canadien ou étranger
  decisionRenduAuQuebec: 2116, // Déclarations obligatoires.Décision rendue au Québec
  poursuiteInfractionsPunissables: 2123, // Déclarations obligatoires.Poursuite pour une infraction punissable de 5 ans ou plus d'emprisonnement
  statutAutorisationDePatique: 2310, // Autorisation de pratique.Statut
  autorisationDePatique: 2311, // Autorisation de pratique.Autorisation
  raisonDuRetrait: 2441, // Demandes d'inscription.Raison du retrait
  reinscriptionPrevue: 2442, // Demandes d'inscription.Prévoyez-vous de vous réinscrire dans les 5 prochaines années ?
  membreAutresOrdres: 2601, // Autre Autorisation de pratique.MembreAutresOrdres
  instancesReglementaires: 2603, // Autre Autorisation de pratique.Instances règlementaires
  assurance: 2902, // Statut d'emploi/Secteur d'activité.Assurance
  statutEmploi: 2904, // Statut d'emploi/Secteur d'activité.Statut d'emploi
  precisionStatutEmploi: 2906, // Statut d'emploi/Secteur d'activité.Précision statut
  communicationsTiers: 3004, // Transmission ordre.Communication à des tiers
  communicationsTiersRaison: 3007, // Transmission ordre.Raison
  communicationsTypesBottin: 3010, // Transmission ordre.Communications types bottin
  contribution: 3028, // Transmission ordre.Contribution
  communicationsRevueIntervention: 3029, // Transmission ordre.Revue d'intervention
  pratiqueActiviteReserve: 6803, // Activité réservée PL18.Déclaration
  precisionActiviteReserve: 6804, // Activité réservée PL18.Déclarer ou modifier la situation actuelle de formation continue
  activiteActiviteReserve: 6806, // Activité réservée PL18.Activités réservées
  activiteAdoptionHorsQuebec: 6807, // Activité réservée PL18.Activité adoption hors Québec
  typeDocument: 11011, // Documents.Type
  categorieAutorisation: 11122, // Adhésions (Inscriptions).Catégorie
  scolariteType: 31802, // Scolarite.Type
  telepratiqueChoix: 32504, // Telepratique.TelepratiqueChoix
  telepratiqueAuQuebec: 32505, // Telepratique.TelepratiqueAuQuebec
};

export const catalogues = {
  // 265 - Contact.Genre
  genre: {
    nonBinaire: 11444, // Non binaire
  },
  // 303 - Organisations.Pays
  pays: {
    canada: 6442, // CANADA
    france: 6475, // FRANCE
    usa: 6402, // ETATS-UNIS
  },
  // 313 - Organisations.Province
  province: {
    quebec: 8086, // Québec
  },
  // 458 - Cartes d'affaires.Service de référence en ligne
  serviceDeReferenceEnLigne: {
    oui: 13752,
  },
  // 1505 - Demandes admission.Origine
  origineDemandeAdmission: {
    admission: 8548, // Admission
    admissionPa: 15291, // Admission PA
    admissionPrp: 15380, // Admission PRP
    readmission: 10760, // Réadmission
    admissionComplementaire: 10880, // Admission complémentaire
    lara: 9105, // LARA
    inscription: 8547, // Inscription
    espaceMembre: 9191, // Espace membre
  },
  // 1510 - Demandes admission.Statut
  statutDemandeAdmission: {
    candidatureNonFinalisee: 8271,
  },
  // 1514 - Demandes admission.Pays d'origine
  paysOrigine: {
    autre: 8168, // Autre
  },
  // 1546 - Demandes admission.Citoyenneté(s)
  citoyennete: {
    autre: 8172, // Autre
  },
  // 1561 - Demandes admission.Motif(s) renonciation
  motifsRenonciationDemandeAdmission: {
    autresMotifs: 15302,
  },
  // 2115 - Déclaration obligatoire
  declarationObligatoireDesicisionTribunal: {
    oui: 9205,
    pardon: 10155,
  },
  // 2310 - Autorisation de pratique.Statut
  statutAutorisationDePatique: {
    inactif: 9075, // Inactif
    radie: 9081, // Radié
    retire: 9082, // Retiré
    membre: 9076, // Membre
    droitsAcquis: 9078, // Droits-acquis
    autoriseInscrire: 10157, // Autorisé à s'inscrire
  },
  // 2325 - Autorisation de pratique.Motif radiation
  motifRadiationAutorisationDePatique: {
    retraitVolontaire: 11767, // Retrait volontaire (Renouvellement)
  },
  // 2902 - Statut d'emploi/Secteur d'activité.Assurance
  assurance: {
    exemption: 9853, // Exemption
    complementaire: 9854, // Exemption avec assurance complémentaire (12$)
  },
  // 2904 - Statut d'emploi/Secteur d'activité.Statut d'emploi
  statutDEmploi: {
    congesDivers: 8583, // Congés divers (+ de 52 semaines)
    congesMaternite: 10207, // Congés parental (+ de 44 semaines)
    enEmploi: 8578, // En emploi
    sansEmploi: 8580, // Sans emploi
    retraiteMoins10ans: 8582, // Retraité (- de 10 ans)
    retraitePlus10ans: 10206, // Retraité (+ 10 ans)
    etudeTempsPleinSansRevenu: 8579, // Études et Maîtrise à temps plein et doctorat sans revenu d'emploi
    benevolat: 8581, // Bénévolat
    autreDomaine: 8585, // Autre domaine d'emploi
    enEmploiCommunautaire: 11798, // En Emploi - Exerçant exclusivement dans une organisation reconnue et financée comme organisme communautaire
    etudeTempsPleinAvecRevenu: 10616, // Étudiant à la Maîtrise à temps plein ou au Doctorat avec revenu d'emploi et avec preuve d'étude
    horsQuebec: 8584, // Hors Québec
  },
  // 2906 - Statut d'emploi/Secteur d'activité.Précision statut
  precisionStatutDEmploi: {
    pratiqueAutonome: 9335,
    autre: 9329,
  },
  // 3004 - Transmission ordre.Communication à des tiers
  transmissionOrdreCommunicationTiers: {
    oui: 8929,
  },
  // 3007 - Transmission ordre.Raison
  transmissionOrdreRaison: {
    autre: 8954,
  },
  // 3028 - Transmission ordre.Contribution
  transmissionOrdreContribution: {
    aucune: 14947,
  },
  // 6806 - Activité réservée PL18.Activités réservées
  activiteActiviteReserve: {
    aucune: 13235,
    evaluationAdoptionEnfant: 13229, // Évaluer une personne qui veut adopter un enfant
  },
  // 11011 - Documents.Type
  typeDocument: {
    declarationJudiciaire: 10982,
    declarationDecisionnelle: 10983,
    instanceJustificatif: 10980,
    declarationDisciplinaire: 10981,
    equivalenceTraduction: 9938,
    equivalenceDiplome: 9940,
    equivalenceNotes: 9941,
    equivalenceDescription: 9942,
    equivalencePlanCours: 9943,
    equivalencePlanCoursPrp: 15472,
    equivalenceAttestationStage: 9944,
    equivalenceAttestationStagePrp: 15475,
    equivalenceCurriculum: 9947,
    equivalenceCurriculumPrp: 15473,
    equivalenceAttestationBenevole: 9946,
    equivalenceEvalComparative: 9939,
    universitaire: 10994,
    expPro: 10995,
    employeur: 9945,
    employeurPrp: 15474,
    preuve: 10997,
    preuveIdentite: 9937,
    formationClf: 10984,
    lettreEngagementFormationAppoint: 11045, // Lettre d'engagement à suivre une formation d'appoint
    attestationParticipationFormations: 10763, // Attestations de participation aux formations
    lettreMotivationPaear: 15320,
    experienceProLettreRecommandation: 15395,
    declarationAssurance: 15484,
  },
  // 11122 - Adhésions (Inscriptions).Catégories autorisation
  categorieAutorisation: {
    travailleurSocial: 8282,
    registreDroitsAcquis: 8296,
    registreDesEtudiants: 8297,
    therapieConjugaleFamiliale: 8283,
    autorisationSpeciale: 8298,
    mediateurFamilial: 9194,
    personneAutorisee: 15288,
  },
  typeMandatBottin: {
    oui: 13181,
    non: 13182,
  },
  // 1801 - Formation.Diplome
  formationDiplome: {
    AutreAutorisationSpeciale: 8576,
    AutreDemandeEquivalenceQuebec: 12811,
    AutreDemandeEquivalenceDiplomeHorsQuebec: 8255,
    AutreMembreInstanceReglementaireTravailSocialCanada: 8256,
    Autre: 10761,
    AutrePersonneAutoriseeActiviteReservee: 15382,
  },
  // 2137 - DeclarationObligatoire.ReclamationFormuleeAupresDUnAssureur
  reclamationFormuleeAupresDUnAssureur: {
    oui: 15482,
    non: 15483,
  },
  // 32504 - Telepratique.TelepratiqueChoix
  telepratiqueChoix: {
    telepratiqueAuQuebec: 15490,
  },
  // 224 - Contact.Pni
  pni: {
    oui: 14223,
  },
  // Valeurs chiffrées
  categoriesDuReproche: {
    UsurpationDUnTitre: "MEb1BVQDhTGECE2svtapwAR1EpL1R1EpL1",
    ExerciceIllegal: "cQVTdyWQzychaAxwK0j3ZAR1EpL1R1EpL1",
    IncitationACommettreUnExerciceIllegal: "T41wHErR1EpL32f1HfUmpmBw0VwR1EpL1R1EpL1",
    IncitationAContrevenirAuCodeDeDeontologie: "cb00jkk5h0HcwDTDR1EpL4J5FowR1EpL1R1EpL1",
  },
};

export const regexCourriel =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const apiAuthType = {
  eudoApi: "x-auth",
  specif: "s-auth",
};

export const pratiqueAutonomeId = "x8D7OnSuZO68HJxFR369EwR1EpL1R1EpL1";

Vue.prototype.$paramFormulaire = paramFormulaire;
Vue.prototype.$cataloguesDesc = cataloguesDesc;
Vue.prototype.$catalogues = catalogues;
Vue.prototype.$regexCourriel = regexCourriel;
